export const selectSearchHub = (state: {searchHub?: string}) => state.searchHub;
